<template>
  <div class="charts-container">
    <div class="inner-charts-container">
      <div class="chart-box">
        <RHPChart />
      </div>

      <div class="chart-box">
        <FuelConsumptionChart />
      </div>

      <div class="chart-box">
        <RobChart />
      </div>

      <div style="height: 20px" />
    </div>
  </div>
</template>

<script>
import RHPChart from "./RHPChart.vue";
import FuelConsumptionChart from "./FuelConsumptionChart.vue";
import RobChart from "./RobChart.vue";

export default {
  name: "FuelCharts",

  components: {
    RHPChart,
    FuelConsumptionChart,
    RobChart,
  },
};
</script>

<style scoped>
.charts-container {
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

.inner-charts-container {
  padding: 0 5px 0 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chart-box {
  min-height: 200px;
  background-color: transparent;
}
</style>
